module.exports = __webpack_public_path__ + "img/mtbbsLogo2.1d65728d.png";